import type { PromptResponse } from '../types/responses';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

class ResponsesApiService {
  private async fetchApi<T>(endpoint: string): Promise<T> {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async getLatestResponses(limit: number = 10): Promise<PromptResponse[]> {
    return this.fetchApi<PromptResponse[]>(`/api/admin/responses?limit=${limit}`);
  }

  async getResponseById(id: number): Promise<PromptResponse> {
    return this.fetchApi<PromptResponse>(`/api/admin/responses/${id}`);
  }
}

export const responsesApiService = new ResponsesApiService();
